import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { GET_WITHOUT_PERMISSION_PACKAGES } from "../types";

export const getPackageWithoutPermission = () => async (dispatch) => {
  try {
    const res = await axios.get("package/permission/without-permission/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({
        type: GET_WITHOUT_PERMISSION_PACKAGES,
        payload: res.data.data,
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
